import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './editpersonal.css';

const ethnicities = [
  {
    value: 'black',
    label: 'African American',
  },
  // {
  //   value: "white",
  //   label: "White",
  // },
  {
    value: 'asian',
    label: 'Asian',
  },
  {
    value: 'latino/hispanic',
    label: 'Latino Hispanic',
  },
  {
    value: 'white/caucasian',
    label: 'European American',
  },
  {
    value: 'middle_eastern',
    label: 'Middle Eastern',
  },
  {
    value: 'native_american',
    label: 'Native American',
  },
  {
    value: 'pacific_islander',
    label: 'Pacific Islander',
  },
  {
    value: 'indian/south_asian',
    label: 'Indian South Asian',
  },
  {
    value: "fba",
    label: "FBA",
  },
  {
    value: 'other',
    label: 'Other',
  },
];

const EditPersonalPopup = ({ initialInfo, onSave, onClose }) => {
  // Initialize state with fallback values in case initialInfo is undefined or null
  const [age, setAge] = useState(initialInfo?.age || '');
  const [location, setLocation] = useState(initialInfo?.location || '');
  const [ethnicity, setEthnicity] = useState(initialInfo?.ethnicity || '');
  const [gender, setGender] = useState(initialInfo?.gender || '');
  const role = localStorage.getItem('role');

  useEffect(() => {
    if (initialInfo) {
      setAge(initialInfo?.age || '');
      setLocation(initialInfo?.location || '');
      setEthnicity(initialInfo?.ethnicity || '');
      setGender(initialInfo?.gender);
    }
  }, [initialInfo]);

  const handleSave = () => {
    if (typeof onSave === 'function') {
      onSave({ age, location, ethnicity, gender });
    } else {
      console.error('onSave is not a function');
    }
    onClose();
  };


  useEffect(() => {
    const selectElement = document.getElementById('ethnicity');
    const options = selectElement?.options;

    const handleMouseOver = (event) => {
      for (let i = 0; i < options?.length; i++) {
        options[i]?.classList.remove('hover');
      }
      event.target.classList.add('hover');
    };

    const handleChange = () => {
      for (let i = 0; i < options?.length; i++) {
        options[i]?.classList?.remove('selected');
        if (options[i]?.selected) {
          options[i]?.classList?.add('selected');
        }
      }
    };

    for (let i = 0; i < options?.length; i++) {
      options[i]?.addEventListener('mouseover', handleMouseOver);
    }
    selectElement?.addEventListener('change', handleChange);

    // Initial call to set the selected option
    handleChange();

    return () => {
      for (let i = 0; i < options?.length; i++) {
        options[i]?.removeEventListener('mouseover', handleMouseOver);
      }
      selectElement?.removeEventListener('change', handleChange);
    };
  }, []);


  return (
    <div className='edit-personal-popup-overlay'>
      <div className='edit-personal-popup-content'>
        <h2 className='edit-personal-popup-title'>Edit Personal Information</h2>
        <form className='edit-personal-form'>
          <div className='edit-personal-form-group'>
            <label htmlFor='age'>Age</label>
            <input
              id='age'
              type='text'
              value={age}
              onChange={(e) => setAge(e.target.value)}
              placeholder='Enter age'
              className='edit-personal-input'
            />
          </div>
          <div className='edit-personal-form-group'>
            <label htmlFor='location'>Location</label>
            <input
              id='location'
              type='text'
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder='Enter location'
              className='edit-personal-input'
            />
          </div>
          {role !== 'crew' && (
            <div className='edit-personal-form-group'>
              <label htmlFor='ethnicity'>Ethnicity</label>
              {/* <input
              id="ethnicity"
              type="text"
              value={ethnicity}
              onChange={(e) => setEthnicity(e.target.value)}
              placeholder="Enter ethnicity"
              className="edit-personal-input"
            /> */}
              <select
                id='ethnicity'
                value={ethnicity}
                onChange={(e) => setEthnicity(e.target.value)}
                className='edit-personal-input custom-select'
              >
                {ethnicities?.map((et) => (
                  <option key={et.value} value={et.value}>
                    {et.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className='edit-personal-form-group'>
            <label htmlFor='gender'>Gender</label>
            <select
              id='gender'
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              className='edit-personal-input'
            >
              <option value=''>Select Gender</option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
              <option value='non-binary'>Non-Binary</option>
              <option value='transgender'>Transgender</option>
            </select>
          </div>
        </form>
        <div className='edit-personal-popup-footer'>
          <button className='edit-personal-save-button' onClick={handleSave}>
            Save
          </button>
          <button className='edit-personal-cancel-button' onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

EditPersonalPopup.propTypes = {
  initialInfo: PropTypes.shape({
    age: PropTypes.string,
    location: PropTypes.string,
    ethnicity: PropTypes.string,
  }),
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditPersonalPopup;
